const pricingPlans = {
    information: [
        {
            planName: 'Annually Pro',
            //planId: 'Annually_Pro',
            planId: 'P-5F661739RM416263LLZULSDQ',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed yearly',
            price: 12.0,
            color: 'blue',
            icon: 'fa-rocket'
        },
        {
            planName: 'Lifetime Pro',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'Forever',
            billed: 'Lifetime',
            price: 249.99,
            color: 'silver',
            icon: 'fa-star'
        },

    ],
    information50Disc: [
        {
            planName: 'Annually Pro',
            //planId: 'Annually_Pro',
            planId: 'P-8FV01820AV227435KMDFTVGI',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed yearly',
            price: 5.25,
            color: 'blue',
            icon: 'fa-rocket'
        },
        {
            planName: 'Lifetime Pro',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'Forever',
            billed: 'Lifetime',
            price: 249.99,
            color: 'silver',
            icon: 'fa-star'
        },

    ],
    information25Disc: [
        {
            planName: 'Annually Pro',
            //planId: 'Annually_Pro',
            planId: 'P-5XX982608S767845MMDFTUCQ',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed yearly',
            price: 7.875,
            color: 'blue',
            icon: 'fa-rocket'
        },
        {
            planName: 'Lifetime Pro',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'Forever',
            billed: 'Lifetime',
            price: 249.99,
            color: 'silver',
            icon: 'fa-star'
        },

    ],
    information10Disc: [
        {
            planName: 'Annually Pro',
            //planId: 'Annually_Pro',
            planId: 'P-827446215P381830KMDFTSTI',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed yearly',
            price: 9.45,
            color: 'blue',
            icon: 'fa-rocket'
        },
        {
            planName: 'Lifetime Pro',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'Forever',
            billed: 'Lifetime',
            price: 249.99,
            color: 'silver',
            icon: 'fa-star'
        },

    ],
    properties: {
        en:[
            {
                item: 'Full Trading Mentor',
                isPro: true,
                basicItem: 'One Insight per week (Mentor)'
            },
            {
                item: 'Trading Plan',
                isPro: true,
                basicItem: 'Without Trading Plan'
            },
            {
                item: 'Create Tournaments',
                isPro: true,
                basicItem: 'No-Tournaments creation'
            },
            {
                item: 'Get Telegram Notifications',
                isPro: true,
                basicItem: 'Without Telegram Notifications'
            },
            {
                item: 'Import Trades',
                isPro: true,
                basicItem: 'No-Trade Importing'
            },
            {
                item: 'Upload the Trade Image',
                isPro: true,
                basicItem: 'No Trade Image'
            },
            {
                item: 'Unlimited Broker Accounts',
                isPro: true,
                basicItem: 'Up to 3 Broker Accounts'
            },
            {
                item: 'Unlimited Strategies',
                isPro: true,
                basicItem: 'Up to 2 Strategies'
            },
            {
                item: 'Unlimited Assets in Watchlist',
                isPro: true,
                basicItem: 'Up to 3 Assets in Watchlist'
            },
            {
                item: 'Unlimited Hits/Mistakes',
                isPro: true,
                basicItem: 'Up to 3 Hits/Mistakes'
            },
            {
                item: 'Chat and Ticket Support',
                isPro: true,
                basicItem: 'Ticket Support'
            },
            {
                item: 'Unlimited Trades per month',
                isPro: false,
            },
            {
                item: 'Automated Journal',
                isPro: false
            },
            {
                item: 'Be part of Communities',
                isPro: false
            },
            {
                item: 'Portfolio Allocation',
                isPro: false
            },
            {
                item: 'Profit Distribution',
                isPro: false
            },
            {
                item: 'Losses Distribution',
                isPro: false
            },
            {
                item: 'P&L per Asset',
                isPro: false
            },
            {
                item: 'P&L per Watchlist',
                isPro: false
            },
            {
                item: 'P&L per Time',
                isPro: false
            },
            {
                item: 'Profit/Risk relation per trade',
                isPro: false
            },
            {
                item: 'Full-Trade View',
                isPro: false
            },
            {
                item: 'Historical Trade Data',
                isPro: false
            },
            {
                item: 'Smart Filter',
                isPro: false
            },
        ],
        es:[
            {
                item: 'Mentor de Trading Full',
                isPro: true,
                basicItem: 'Solo un insight <br>por semana (Mentor)'
            },
            {
                item: 'Ilimitados Planes de Trading',
                isPro: true,
                basicItem: 'Sin Trading Plan'
            },
            {
                item: 'Crea Ilimitados Torneos',
                isPro: true,
                basicItem: 'No puedes crear Torneos'
            },
            {
                item: 'Notificaciones en Telegram',
                isPro: true,
                basicItem: 'Sin Notificaciones en Telegram'
            },
            {
                item: 'Importación de Trades',
                isPro: true,
                basicItem: 'Sin posibilidad<br>de Importar Trades'
            },
            {
                item: 'Sube Imagen del Trade',
                isPro: true,
                basicItem: 'Sin Imagen del Trade'
            },
            {
                item: 'Ilimitadas Cuentas de Broker',
                isPro: true,
                basicItem: 'Máximo 3 cuentas<br>de Broker'
            },
            {
                item: 'Ilimitadas Estrategias',
                isPro: true,
                basicItem: 'Máximo 2 estrategias'
            },
            {
                item: 'Ilimitados Activos<br> en la lista de seguimiento',
                isPro: true,
                basicItem: 'Máximo 3 activos <br> en la lista de seguimiento'
            },
            {
                item: 'Ilimitados Aciertos/Errores',
                isPro: true,
                basicItem: 'Máximo 3 Aciertos/Errores'
            },
            {
                item: 'Soporte vía Chat y Ticket',
                isPro: true,
                basicItem: 'Soporte vía Ticket'
            },
            {
                item: 'Trades Ilimitados por mes',
                isPro: false,
            },
            {
                item: 'Bitácora automatizada',
                isPro: false
            },
            {
                item: 'Sé parte de Comunidades',
                isPro: false
            },
            {
                item: 'Distribución de portafolio',
                isPro: false
            },
            {
                item: 'Distribución de ganancias',
                isPro: false
            },
            {
                item: 'Distribución de perdidas',
                isPro: false
            },
            {
                item: 'P&L por activo',
                isPro: false
            },
            {
                item: 'P&L por lista de seguimiento',
                isPro: false
            },
            {
                item: 'P&L por tiempo',
                isPro: false
            },
            {
                item: 'Relación Ganancia/Perdida <br> por trade',
                isPro: false
            },
            {
                item: 'Vista completa <br> de los trades',
                isPro: false
            },
            {
                item: 'Datos históricos <br>de los trades',
                isPro: false
            },
            {
                item: 'Filtro inteligente',
                isPro: false
            },
        ]
    }
};

export default pricingPlans;
